
export type PhoneNumberOption = {
  label: string;
  phone_number: string;
};

export type PhoneNumberOptions = Array<PhoneNumberOption>;

export const PhoneNumberOptionTypeMap = {
  CONTACTS: 'contacts',
  TWILIO: 'twilio',
  VIA: 'via',
} as const;

export type PhoneNumberOptionType = typeof PhoneNumberOptionTypeMap[keyof typeof PhoneNumberOptionTypeMap];

export const ContactsMap: {
  [phone_number: string]: PhoneNumberOptions,
} = {
  '+18012109791': [
    {
      label: 'Kerianne',
      phone_number: '+13076773969'
    },
    {
      label: 'Mountain View Dental',
      phone_number: '+13852157222'
    },
    {
      label: 'Jed Allred',
      phone_number: '+14356099138'
    },
    {
      label: 'Aunt Marie',
      phone_number: '+14357492729'
    },
    {
      label: 'Kerianne - OLD',
      phone_number: '+14357499656'
    },
    {
      label: 'MACU',
      phone_number: '+18013256228'
    },
    {
      label: 'Jedydyah',
      phone_number: '+18016031041'
    },
    {
      label: 'Aunt Rene',
      phone_number: '+18016361623'
    },
    {
      label: 'Tresa',
      phone_number: '+18016912933'
    },
    {
      label: 'Phil - Neighbor',
      phone_number: '+18018887031'
    },
    {
      label: 'Ignore',
      phone_number: '+18103215577'
    },
    {
      label: 'Shawn\'s Cell',
      phone_number: '+13855151703'
    },
    {
      label: 'Kirstla\'s Cell',
      phone_number: '+13855152771'
    },
  ],
  '+13854744766': [
    {
      label: 'Mike Kenworthy',
      phone_number: '+13852257959'
    },
    {
      label: 'Becky Allred Cell',
      phone_number: '+14354949922'
    },
    {
      label: 'Andy Ostler',
      phone_number: '+14355572680'
    },
    {
      label: 'Jed Allred Cell',
      phone_number: '+14356099138'
    },
    {
      label: 'Debby Ostler',
      phone_number: '+14357549242'
    },
    {
      label: 'Stephanie Hanks',
      phone_number: '+14357549479'
    },
    {
      label: 'Rene Daily (Kirstla\'s Aunt)',
      phone_number: '+18016361623'
    },
    {
      label: 'Tresa Skinner',
      phone_number: '+18016912933'
    },
    {
      label: 'Trevor Ostler',
      phone_number: '+18016962943'
    },
    {
      label: 'Kirstla\'s Cell',
      phone_number: '+13855152771'
    },
    {
      label: 'Shawn\'s Cell',
      phone_number: '+13855151703'
    },
  ],
  '+13854744970': [
    {
      label: 'Kerianne',
      phone_number: '+13076773969'
    },
    {
      label: 'Shawn\'s Cell',
      phone_number: '+13855151703'
    },
    {
      label: 'Maryn',
      phone_number: '+14352251094'
    },
    {
      label: 'Becky',
      phone_number: '+14354949922'
    },
    {
      label: 'Jorgen',
      phone_number: '+14356096534'
    },
    {
      label: 'Jed Allred',
      phone_number: '+14356099138'
    },
    {
      label: 'Aunt Marie',
      phone_number: '+14357492729'
    },
    {
      label: 'Debby Ostler',
      phone_number: '+14357549242'
    },
    {
      label: 'Seed & Smith',
      phone_number: '+17867892765'
    },
    {
      label: 'Jedydyah',
      phone_number: '+18016031041'
    },
    {
      label: 'Tresa',
      phone_number: '+18016912933'
    },
    {
      label: 'Dakin',
      phone_number: '+18016913260'
    },
  ],
  '+18013353562': [],
  '+13854128665': [],
  '+18667217770': [],
  '+18667217778': [],
  '+13856005727': [
    {
      "label": "Ariel - Hartstring Creations",
      "phone_number": '+13854982935'
    }
  ],
} as const;

export const TwilioPhoneNumbers: PhoneNumberOptions = [
  {
    label: 'SKO',
    phone_number: '+18012109791'
  },
  {
    label: 'Shawn Public',
    phone_number: '+13854744766'
  },
  {
    label: 'Kirstla Public',
    phone_number: '+13854744970'
  },
  {
    label: 'IncDev',
    phone_number: '+18013353562'
  },
  {
    label: 'DTB',
    phone_number: '+13854128665'
  },
  {
    label: 'BCX 1',
    phone_number: '+18667217770'
  },
  {
    label: 'BCX 2',
    phone_number: '+18667217778'
  },
];

export const ViaPhoneNumbers: PhoneNumberOptions = [
  {
    label: 'Shawn\'s Cell',
    phone_number: '+13855151703'
  },
  {
    label: 'Kirstla\'s Cell',
    phone_number: '+13855152771'
  },
];
